import IconSpeedometer from './IconSpeedometer.vue';
import IconEnergy from './IconEnergy.vue';
import IconBadge from './IconBadge.vue';
import IconWrench from './IconWrench.vue';
import IconGlobe from './IconGlobe.vue';
import IconFire from './IconFire.vue';
import IconLayers from './IconLayers.vue';
import IconPicture from './IconPicture.vue';
import IconShop from './IconShop.vue';
import IconMegaphone from './IconMegaphone.vue';
import IconEye from './IconEye.vue';
import IconTrash from './IconTrash.vue';
import IconEdit from './IconEdit.vue';
import IconPlus from './IconPlus.vue';
import IconArrowLeft from './IconArrowLeft.vue';
import IconOrganization from './IconOrganization.vue';

export {
        IconSpeedometer,
        IconEnergy,
        IconBadge,
        IconWrench,
        IconGlobe,
        IconFire,
        IconLayers,
        IconPicture,
        IconShop,
        IconMegaphone,
        IconEye,
        IconTrash,
        IconEdit,
        IconPlus,
        IconArrowLeft,
        IconOrganization,
};

export const iconMap = {
        'si si-speedometer': IconSpeedometer,
        'si si-energy': IconEnergy,
        'si si-badge': IconBadge,
        'si si-wrench': IconWrench,
        'si si-globe': IconGlobe,
        'si si-fire': IconFire,
        'si si-layers': IconLayers,
        'si si-picture': IconPicture,
        'si si-shop': IconShop,
        'si si-megaphone': IconMegaphone,
        'si si-organization': IconOrganization,
};
